import { campoDeveSerMaiorIgual, campoDeveSerMenor, campoObrigatorio } from 'helpers/Constantes/Mensagens'
import { TipoProjetoEnum } from './Enum/TipoProjetoEnum'

export type DadosGerais = {
  areaTerrenoBruta: string
  areaTerrenoDescontar: string
  areaTerrenoLiquida: string
  nomeViabilidade: string
  numeroCondominio: string
  tipoProjeto: string
  valorMoedaMrvAtual: string
  valorMoedaMrvCompra: string
  modeloNegocio: string
  linhaProduto: string
  valido: boolean
}

export const dadosGeraisValorDefault = {
  areaTerrenoBruta: '',
  areaTerrenoDescontar: '',
  areaTerrenoLiquida: '',
  nomeViabilidade: '',
  numeroCondominio: '',
  tipoProjeto: '',
  valorMoedaMrvAtual: '',
  valorMoedaMrvCompra: '',
  modeloNegocio: '',
  linhaProduto: ''
} as DadosGerais

export class ValidacaoDadosGerais {
  areaTerrenoBruta: string
  areaTerrenoDescontar: string
  nomeViabilidade: string
  numeroCondominio: string
  tipoProjeto: string
  modeloNegocio: string
  linhaProduto: string

  constructor(
    areaTerrenoBruta = '',
    areaTerrenoDescontar = '',
    nomeViabilidade = '',
    numeroCondominio = '',
    tipoProjeto = '',
    modeloNegocio = '',
    linhaProduto = ''
  ) {
    this.areaTerrenoBruta = areaTerrenoBruta
    this.areaTerrenoDescontar = areaTerrenoDescontar
    this.nomeViabilidade = nomeViabilidade
    this.numeroCondominio = numeroCondominio
    this.tipoProjeto = tipoProjeto
    this.modeloNegocio = modeloNegocio
    this.linhaProduto = linhaProduto
  }

  validarAreaTerrenoBruta(areaTerrenoBruta: string, areaTerrenoPoligono: string): string {
    let error = ''
    if (parseFloat(areaTerrenoBruta) < parseFloat(areaTerrenoPoligono)) {
      error = campoDeveSerMaiorIgual + areaTerrenoPoligono
    }

    if (areaTerrenoBruta === '') {
      error = campoObrigatorio
    }

    return error
  }

  validarAreaTerrenoDescontar(areaTerrenoDescontar: string, areaTerrenoBruta: string): string {
    let error = ''

    if (parseFloat(areaTerrenoDescontar) >= parseFloat(areaTerrenoBruta)) {
      error = campoDeveSerMenor + 'área do terreno bruta'
    }

    return error
  }

  validarNomeViabilidade(nomeViabilidade: string): string {
    let error = ''

    if (!nomeViabilidade || nomeViabilidade === '') {
      error = campoObrigatorio
    }

    return error
  }

  validarModeloNegocio(modeloNegocio: string): string {
    let error = ''

    if (!modeloNegocio || modeloNegocio === '') {
      error = campoObrigatorio
    }

    return error
  }

  validarTipoProjeto(tipoProjeto: string): string {
    let error = ''

    if (!tipoProjeto || tipoProjeto === '') {
      error = campoObrigatorio
    }

    return error
  }

  validarLinhaProduto(linhaProduto: string): string {
    let error = ''

    if (!linhaProduto || linhaProduto === '') {
      error = campoObrigatorio
    }

    return error
  }

  validarTodosCampos(state: DadosGerais): boolean {
    if (
      state.tipoProjeto === TipoProjetoEnum.LoteamentoAberto &&
      this.areaTerrenoBruta === '' &&
      this.areaTerrenoDescontar === '' &&
      state.nomeViabilidade != '' &&
      this.nomeViabilidade === '' &&
      state.linhaProduto != '' &&
      this.linhaProduto === '' &&
      state.modeloNegocio != '' &&
      this.modeloNegocio === ''
    ) {
      return true
    }

    if (
      state.tipoProjeto === TipoProjetoEnum.CondominioIncorporacao &&
      this.areaTerrenoBruta === '' &&
      this.areaTerrenoDescontar === '' &&
      state.nomeViabilidade != '' &&
      this.nomeViabilidade === '' &&
      state.linhaProduto != '' &&
      this.linhaProduto === '' &&
      state.numeroCondominio != '' &&
      this.numeroCondominio === ''
    ) {
      return true
    }

    return false
  }
}
